import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectBuildInfo } from 'app/store/websocketStatus';
import { BuildInfo } from './BuildInfo.jsx';

const mapStateToProps = createStructuredSelector({
    buildInfo: selectBuildInfo
});

export const BuildInfoContainer = connect(mapStateToProps)(BuildInfo);
